import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Pagination, PaginationParams} from '../model/pagination';
import {LocationDto} from '../model/continent';
import {cleaningParams} from '../functions/cleaningParams';

@Injectable({
  providedIn: 'root'
})
export class RouteService {
  constructor(private httpClient: HttpClient) {}
  private mapId: BehaviorSubject<string> = new BehaviorSubject<string>('658305');
  private route: BehaviorSubject<LocationDto> = new BehaviorSubject<LocationDto>(new LocationDto());
  private currentIndex: number = 0;
  routes: LocationDto[] = [];

  getMapId() {
    return this.mapId.value;
  }
  setMapId(value: string) {
    this.mapId.next(value);
  }

  getRouteList(params: PaginationParams): Observable<Pagination<LocationDto>> {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    return this.httpClient.get<Pagination<LocationDto>>(
      `${environment.apiUrl}/public/route`,
      { params: filteredParams }
    );
  }

  getRoute(id: number): Observable<LocationDto>  {
    return this.httpClient.get<LocationDto>(`${environment.apiUrl}/public/route/${id}`);
  }

  getRouteByUrl(url: string): Observable<LocationDto>  {
    return this.httpClient.get<LocationDto>(`${environment.apiUrl}/public/route/by-url/${url}`);
  }

  moveUpPoint(id: number, pointId: number): Observable<boolean>  {
    return this.httpClient.put<boolean>(`${environment.apiUrl}/route/point/move-up/${id}/${pointId}`, id);
  }

  moveDownPoint(id: number, pointId: number): Observable<boolean> {
    return this.httpClient.put<boolean>(`${environment.apiUrl}/city/move-down/${id}/${pointId}`, id);
  }


  saveRouteFooterPhoto(id: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/route/footer/file/${id}`, formData);
  }

  deleteRouteFooterPhoto(id: number) {
    return this.httpClient.delete(`${environment.apiUrl}/route/footer/file/${id}`);
  }

  saveRouteFile(id: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/route/file/${id}`, formData);
  }

  deleteRouteFile(id: number) {
    return this.httpClient.delete(`${environment.apiUrl}/route/file/${id}`);
  }

  saveRouteCarousel(idRoute: number, idCarousel: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/route/file/${idRoute}/${idCarousel}`, formData);
  }

  deleteRouteCarousel(idRoute: number, idCarousel: number,) {
    return this.httpClient.delete(`${environment.apiUrl}/route/${idRoute}/${idCarousel}`);
  }

  saveRoute(Route: LocationDto): Observable<LocationDto> {
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/route`, Route);
  }

  delete(id: number) {
    return this.httpClient.delete(`${environment.apiUrl}/route/${id}`);
  }

  savePointEventPhoto(idRoute: number, pointId: number, eventId: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/route/file/point/event/${idRoute}/${pointId}/${eventId}`, formData);
  }

  deletePointEvent(idRoute: number, pointId: number, eventId: number,) {
    return this.httpClient.delete(`${environment.apiUrl}/route/file/point/event/${idRoute}/${pointId}/${eventId}`);
  }

  deletePointEvent1(idRoute: number, pointId: number, eventId: number,) {
    return this.httpClient.delete(`${environment.apiUrl}/route/point/event/${idRoute}/${pointId}/${eventId}`);
  }

  deletePoint(idRoute: number, pointId: number) {
    return this.httpClient.delete(`${environment.apiUrl}/route/point/${idRoute}/${pointId}`);
  }

  setRandom() {
    if (this.routes.length === 0) {
      this.route.next(new LocationDto());
      return;
    }
    this.currentIndex = (this.currentIndex + 1) % this.routes.length;
    this.route.next(this.routes[this.currentIndex]);
  }

  getRandom(): LocationDto {
    if (this.routes.length === 0) {
      return new LocationDto();
    }
    if (this.currentIndex > this.routes.length) {
      this.currentIndex = 0;
    }
    return this.routes[this.currentIndex];
  }

  setAndShuffleCountries(countries: LocationDto[]) {
    this.routes = this.shuffleArray([...countries]);
    this.currentIndex = 0;
  }

  private shuffleArray(array: LocationDto[]): LocationDto[] {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  }

}
